export default __webpack_public_path__ + "static/media/map_overlay.e45a3a78.webp";